<template>
  <table :class="currentClass">
    <slot
      :tbody-class="theadClass.thead"
      :tr-class="theadClass.tr"
      :th-class="theadClass.th"
      :data="normalizedHeaders"
      name="thead"
    >
      <thead v-if="normalizedHeaders.length > 0" :class="theadClass.thead">
        <tr :class="theadClass.tr">
          <th
            v-for="({ text, className, id }, index) in normalizedHeaders"
            :id="id"
            :key="index"
            :class="[theadClass.th, className]"
            style="text-overflow: ellipsis; overflow: hidden; white-space: no-wrap"
          >
            {{ text }}
          </th>
        </tr>
      </thead>
    </slot>
    <slot
      :tbody-class="tbodyClass.tbody"
      :tr-class="tbodyClass.tr"
      :td-class="tbodyClass.td"
      :th-class="theadClass.th"
      :data="data"
      :headers="normalizedHeaders"
      name="tbody"
    >
      <tbody :class="tbodyClass.tbody">
        <slot
          v-for="(row, rowIndex) in data"
          :row-index="rowIndex"
          :tr-class="tbodyClass.tr"
          :td-class="tbodyClass.td"
          :row="row"
          name="row"
        >
          <tr :key="rowIndex" :class="tbodyClass.tr">
            <slot
              v-for="(text, columnIndex) in getRowColumns(row)"
              :row-index="rowIndex"
              :column-index="columnIndex"
              :td-class="tbodyClass.td"
              :text="text"
              name="column"
            >
              <td :key="`${rowIndex}-${columnIndex}`" :class="tbodyClass.td">
                {{ text }}
              </td>
            </slot>
          </tr>
        </slot>
      </tbody>
    </slot>
    <slot
      :tfoot-class="tfootClass.tfoot"
      :tr-class="tfootClass.tr"
      :td-class="tfootClass.td"
      :data="normalizedFooters"
      :headers="normalizedHeaders"
      name="tfoot"
    >
      <tfoot v-if="normalizedFooters.length > 0" :class="tfootClass.tfoot">
        <tr :class="tfootClass.tr">
          <td
            v-for="({ text, className, id }, index) in normalizedFooters"
            :id="id"
            :key="index"
            :class="[tfootClass.td, className]"
          >
            {{ text }}
          </td>
        </tr>
      </tfoot>
    </slot>
  </table>
</template>

<script>
import TableTheme from '@/components/theme/TableTheme'

const { tableClass, theadClass, tbodyClass, tfootClass } = TableTheme
export default {
  name: 'Table',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    footers: {
      type: Array,
      default: () => [],
    },
    tableClass: {
      type: [String, Object, Array],
      default: tableClass,
    },
    theadClass: {
      type: Object,
      default: () => theadClass,
    },
    tbodyClass: {
      type: Object,
      default: () => tbodyClass,
    },
    tfootClass: {
      type: Object,
      default: () => tfootClass,
    },
  },
  computed: {
    normalizedHeaders() {
      return this.headers.map(header => {
        if (typeof header === 'string') {
          return {
            text: header,
          }
        }
        return header
      })
    },
    normalizedFooters() {
      return this.footers.map(footer => {
        if (typeof footer === 'string') {
          return {
            text: footer,
          }
        }
        return footer
      })
    },
    headersValues() {
      return this.headers.filter(h => h.value).map(h => h.value)
    },
    /**
     * The default classes for the table
     *
     * @return {Array}
     */
    currentClass() {
      const classes = [`${this.$options._componentTag}`]
      if (this.tableClass) {
        classes.push(this.tableClass)
      }
      return classes
    },
  },
  methods: {
    getColumnsByKey(obj, keys) {
      const arr = []
      for (const key of keys) {
        arr.push(obj[key])
      }
      return arr
    },
    getRowColumns(row) {
      return this.getColumnsByKey(row, this.headersValues)
    },
  },
}
</script>
